<template>
  <van-popup
    v-model="visible"
    round
    class="prize-dialog-popup"
    overlay-class="prize-dialog-overlay"
    get-container="body"
    :close-on-click-overlay="false"
  >
    <div class="prize-dialog" v-if="prize">
      <div class="prize-dialog__title">恭喜抽中</div>
      <div class="prize-dialog__icon">
        <img v-if="prize.image" :src="prize.image" alt="">
        <span v-else>{{ icon }}</span>
      </div>
      <div class="prize-dialog__name">{{ prize.prize_name }}</div>
      <button @click="$emit('close')">完成</button>
      <div class="prize-dialog__status">奖品已自动发放到你的账户</div>
    </div>
  </van-popup>
</template>

<script>
import { prizeTypeName } from '../utils'

export default {
  name: 'WorldCupQuizPrizeDialog',
  props: {
    show: Boolean,
    prize: Object
  },
  computed: {
    visible: {
      get () {
        return this.show
      },
      set () {}
    },
    icon () {
      return this.prize ? prizeTypeName(this.prize.prize_type).slice(0, 1) : '奖'
    }
  }
}
</script>

<style scoped lang="scss">
.prize-dialog {
  position: relative;
  width: 313px;
  height: 373px;
  padding: 35px 35px 0;
  overflow: hidden;
  box-sizing: border-box;
  text-align: center;
  color: #fff6b6;
  background: url('~@/assets/image/worldcupQuiz/prize-dialog-bg.png') center/100% 100% no-repeat;
}

.prize-dialog__title,
.prize-dialog__icon,
.prize-dialog__name,
.prize-dialog__status,
button {
  position: relative;
  z-index: 1;
}

.prize-dialog__title {
  margin-top: -8px;
  color: #fff6b6;
  font-family: "Alimama ShuHeiTi", "PingFang SC", sans-serif;
  font-size: 40px;
  font-weight: 700;
  line-height: 49px;
  letter-spacing: 0;
  text-shadow:
    0 2px 0 #00540f,
    0 -2px 0 #00540f,
    2px 0 0 #00540f,
    -2px 0 0 #00540f,
    0 4px 4px rgba(0, 0, 0, .25);
}

.prize-dialog__icon {
  width: 92px;
  height: 92px;
  margin: 28px auto 14px;
  border-radius: 50%;
  color: #fff;
  border: 5px solid rgba(255, 230, 105, .82);
  background: radial-gradient(circle at 50% 45%, #fff6b6 0%, #ffd95c 64%, #f5a62f 100%);
  line-height: 82px;
  font-size: 42px;
  font-weight: 900;
}

.prize-dialog__icon img {
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 50%;
  object-fit: cover;
}

.prize-dialog__name {
  color: #fff6b6;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
}

.prize-dialog__status {
  margin-top: 9px;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
}

button {
  width: 243px;
  height: 48px;
  margin-top: 20px;
  border: 0;
  border-radius: 24px;
  color: #145720;
  background: linear-gradient(180deg, #ffe648 0%, #ffb65a 100%);
  font-size: 16px;
  font-weight: 600;
  line-height: 48px;
}

</style>

<style lang="scss">
.prize-dialog-popup.van-popup {
  z-index: 120 !important;
  overflow: visible;
  background: transparent;
}

.prize-dialog-overlay {
  z-index: 119 !important;
  background: rgba(0, 0, 0, .6);
}
</style>
